import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';
import { PatientCacheRef, PatientServiceEvents } from './usePatientService';

export const useRemoveRiskGap = (events: PatientServiceEvents, patientCache: PatientCacheRef) => {
    const services = React.useContext(ServicesContext);

    const removeRiskGap = useCallback(
        async (id: number, patientId: number) => {
            await services.api.call({
                method: 'delete',
                url: `/api/risk-gaps/${id}`,
            });

            patientCache.current[patientId].risk_gaps = patientCache.current[
                patientId
            ].risk_gaps.filter((x) => x.id !== id);

            services.events.publish(events.notes_updated);
            services.events.publish(events.patient_updated);
        },
        [services.api, services.events, events, patientCache]
    );

    return removeRiskGap;
};
